import { render } from "./Footer.vue?vue&type=template&id=16f0767b&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=16f0767b&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f0767b"]])

export default __exports__